import { useQuery } from "@apollo/client";
import { UserGroupsDocument } from "../../../../../../../__generated__/graphql";

export default function useUserGroups() {
  const { data, loading, error, refetch } = useQuery(UserGroupsDocument);

  return {
    userGroups: data?.userGroups ?? [],
    loading,
    error,
    refetch,
  };
}
